import React from "react";
import { StatusToggleSwitch } from "../StatusToggleSwitch";
import { packageClassStatus } from "../../redux/features/mastersSlice";

export const PackageClassesStatus = ({ params }) => {
    return (
        <div>
            <StatusToggleSwitch
                initialValue={params.isActive}
                api={packageClassStatus(params.packageClassId)}
            />
        </div>
    );
};
